var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 5.125C17.875 4.23125 17.1438 3.5 16.25 3.5H3.25C2.35625 3.5 1.625 4.23125 1.625 5.125V14.875C1.625 15.7688 2.35625 16.5 3.25 16.5H16.25C17.1438 16.5 17.875 15.7688 17.875 14.875V5.125ZM16.25 5.125L9.75 9.1875L3.25 5.125H16.25ZM16.25 14.875H3.25V6.75L9.75 10.8125L16.25 6.75V14.875Z",
    fill: "#6d4096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.c4d1eaee3332a95b946c7f87864110ab.svg";
export { ForwardRef as ReactComponent };